import React, { createContext, useContext, useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import SupportBanner from './SupportBanner';
import UpdateBanner from '../Pwa/UpdateBanner';
import { useTheme } from '../../contexts/ThemeContext';
import './Layout.css';

// Dentro de um layout já aberto, outro layout não se abre. Isto permite pôr o layout NO ROUTER (uma só vez, para todas as páginas do sócio)
// sem partir as páginas que ainda se embrulham a si próprias: a de dentro limita-se a devolver o conteúdo.
const InsideLayoutContext = createContext(false);

const DashboardLayout = ({ children, userType = 'client' }) => {
  const inside = useContext(InsideLayoutContext);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  // O tema é do ThemeProvider (App): o botão do cabeçalho e as Definições mexem no MESMO estado.
  // Antes eram dois interruptores com chaves diferentes (`darkMode` vs `isDarkMode`/`theme`) e a
  // barra lateral/campos ficavam meio escuros (ver utils/theme.js).
  const { isDarkMode, toggleTheme } = useTheme();

  // Check for mobile
  useEffect(() => {
    if (inside) return undefined;
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsCollapsed(true);
        setIsMobileMenuOpen(false);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [inside]);

  if (inside) return <>{children}</>;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <InsideLayoutContext.Provider value>
      <div className={`dashboard-layout ${isCollapsed ? 'sidebar-collapsed' : ''}`}>
        <Sidebar
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed}
          userType={userType}
          isMobileOpen={isMobileMenuOpen}
          onCloseMobile={() => setIsMobileMenuOpen(false)}
        />
        {isMobileMenuOpen && <div className="mobile-overlay" onClick={() => setIsMobileMenuOpen(false)} />}
        <div className="main-content">
          <SupportBanner />
          <Header
            onToggleTheme={toggleTheme}
            isDarkMode={isDarkMode}
            onToggleMobileMenu={toggleMobileMenu}
          />
          <main className="content-area">
            {children}
          </main>
        </div>
        {/* Aviso de versão nova: vale para a área do atleta E para a administração, por isso vive no painel e não numa página. */}
        <UpdateBanner />
      </div>
    </InsideLayoutContext.Provider>
  );
};

export default DashboardLayout;
